import PrivateLayout from "@/components/layouts/private-layout";
import ViewPayment from "@/pages/payments/view-payment";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/payments/$paymentId")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <ViewPayment />
    </PrivateLayout>
  );
}
